// export * from './date/quarter'
import { compare, isBetween } from './date/compare.ts'
import { detect } from './date/detect.ts'
import { format } from './date/format.ts'
import { parse } from './date/parse.ts'
import { quarterRange, range } from './date/range.ts'

export const dateUtil = {
  compare,
  isBetween,
  range,
  quarterRange,
  format,
  detect,
  parse,
}
